/* eslint-disable */
import styled from "styled-components";

import colors from "../../constants/color";
import materialUI from "../../material-UI";

export const ContainerModal = styled(materialUI.DialogContent)`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0 0 32px 0;
  /* position: relative; */
`;

export const DialogHeader = styled(materialUI.DialogTitle)`
  padding: 24px 24px 0 24px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 48px;
`;
export const TitleHeader = styled.div`
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  color: ${colors.gray900};
  font-family: Inter-Medium;

  svg {
    margin-right: 20px;
  }
`;

export const TitleHeaderTwo = styled.div`
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  color: ${colors.gray900};
  font-family: Inter-Medium;
  margin-top: 20px;
`;
export const Footer = styled(materialUI.DialogActions)`
  display: flex;
  width: 100%;
  max-width: 500px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  background-color: #ffffff;
  padding-top: 0;
  position: absolute;
  bottom: 0;
  border-radius: 0px 0px 4px 4px;
`;
export const FooterFixed = styled(materialUI.DialogActions)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  background-color: #ffffff;
  padding-top: 0;
`;
export const ButtonClose = styled.button`
  height: 43px;
  border: 1px solid #a3a3a6;
  border-radius: 8px;
  width: 100%;
  color: #424248;
  cursor: pointer;
  font-size: 16px;
  line-height: 120%;
  font-family: Inter-Medium;
  background-color: white;
  transition: all 0.5s;
  margin-top: 24px;

  &:hover {
    background-color: #ececec;
  }
`;
export const Modal = styled(materialUI.Dialog)`
  .MuiDialog-paper {
    overflow: unset;
  }
  .MuiDialog-paperWidthSm {
    max-width: 1000px;
  }
  &.shake-true {
    .MuiDialog-paper {
      /* Start the shake animation and make the animation last for 0.5 seconds */
      animation: shake 0.8s;

      /* When the animation is finished, start again */
      animation-iteration-count: infinite;
    }

    @keyframes shake {
      0% {
        transform: translate(1px, 1px) rotate(0deg);
      }
      10% {
        transform: translate(-1px, -2px) rotate(-1deg);
      }
      20% {
        transform: translate(-3px, 0px) rotate(1deg);
      }
      30% {
        transform: translate(3px, 2px) rotate(0deg);
      }
      40% {
        transform: translate(1px, -1px) rotate(1deg);
      }
      50% {
        transform: translate(-1px, 2px) rotate(-1deg);
      }
      60% {
        transform: translate(-3px, 1px) rotate(0deg);
      }
      70% {
        transform: translate(3px, 1px) rotate(-1deg);
      }
      80% {
        transform: translate(-1px, -1px) rotate(1deg);
      }
      90% {
        transform: translate(1px, 2px) rotate(0deg);
      }
      100% {
        transform: translate(1px, -2px) rotate(-1deg);
      }
    }
  }
`;
export const Divider = styled(materialUI.Divider)``;
export const IconButton = styled(materialUI.IconButton)`
  cursor: pointer;
  color: ${colors.gray500};
`;
export const CircularProgress = styled(materialUI.CircularProgress)`
  margin-top: 2px;
`;

export const TransferComponent = styled.div`
  padding: 24px;
  padding-top: 0;
  min-height: 180px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const TransferComponentTarefas = styled.div`
  padding: 4px 24px;
`;

export const MultipleTransferComponent = styled.div`
  padding: 24px;
  padding-top: 0;
  min-height: 320px;
`;

export const FieldDiv = styled.div`
  padding: 24px;
  padding-top: 0;
`;

export const FormComponent = styled.div`
  margin-bottom: 93px;
`;

export const MultLineField = styled.div`
  position: relative;
  margin-top: 8px;
  width: 100%;
  .button-file {
    width: 100%;
    height: 43px;
    border-radius: 8px;
    color: ${colors.Mediumgrey};
    text-transform: none;
    border: 1px solid ${colors.Mediumgrey};
    border-style: dashed;
    display: inline-flex;
    flex-wrap: wrap;
  }
`;

export const CountText = styled.span`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: ${colors.grey1};
  background: ${colors.White};
  position: absolute;
  right: 20px;
  bottom: 10px;
`;

export const TextField = styled(materialUI.TextField)`
  margin-top: 2px;
  label {
    display: none;
  }
  legend {
    span {
      display: none;
    }
  }
  .MuiInputBase-adornedEnd {
    min-height: 42px;
  }
  .MuiInputBase-root {
    border-radius: 8px;
    .MuiAutocomplete-input {
      padding: 2px 4px;
    }
  }
  .Mui-focused {
    fieldset {
      border-color: ${colors.primary} !important;
    }
  }
  &.input-disabled {
    background-color: ${colors.gray100};
    input {
      color: ${colors.grey1};
    }
  }
  textarea {
    position: relative;
    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background: ${colors.LigthGrey};
    }
  }
`;
export const LabelText = styled.span`
  display: flex;
  flex-direction: row;
  font-size: 14px;
  line-height: 150%;
  color: #333333;
  font-family: Inter-Medium;
  margin-bottom: 5px;

  p {
    color: red;
    margin-left: 4px;
  }
`;

export const LinkButton = styled.a`
  background-color: ${colors.primary};
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border: 1px solid ${colors.primary};
  width: 100%;
  color: ${colors.white};

  border-radius: 8px;
  padding: 14px;
  text-align: center;
  text-decoration: none;
  font-family: Inter-Medium;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 120%;
  transition: all 0.3s;

  &:hover {
    background-color: ${colors.Primaryv1};
  }
`;

export const Button = styled(materialUI.Button)`
  width: calc(50% - 8px);
  height: 43px;
  border-radius: 8px;
  border: 1px solid ${colors.Mediumgrey};
  span {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Inter-Medium;
    font-size: 16px;
    line-height: 24px;
    text-transform: capitalize;
    color: ${colors.Black};
  }
  &.transfer-btn {
    background-color: ${colors.primary};
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
    border: 1px solid ${colors.primary};
    span {
      color: ${colors.white};
    }
  }
  &.error-btn {
    background-color: ${colors.error};
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
    border: 1px solid ${colors.error};
    span {
      color: ${colors.white};
    }
  }
  &.redirect-btn {
    background-color: ${colors.primary};
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
    border: 1px solid ${colors.primary};
    width: 100%;
    span {
      color: ${colors.white};
    }
  }
  .MuiCircularProgress-root {
    width: 20px !important;
    height: 20px !important;
    color: ${colors.white};
  }
`;

export const SaveButton = styled(materialUI.Button)`
  width: calc(50% - 8px);
  height: 43px;
  border-radius: 8px;
  border: 1px solid ${colors.Mediumgrey};
  background-color: ${colors.primary};
  span {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Inter-Medium;
    font-size: 16px;
    line-height: 24px;
    text-transform: capitalize;
    color: ${colors.white};
  }
`;

export const ButtonAnexo = styled(materialUI.Button)`
  width: 100%;
  height: 43px;
  border-radius: 8px;
  color: ${colors.Mediumgrey};
  text-transform: none;
  border: 1px solid ${colors.Mediumgrey};
  border-style: dashed;
  display: inline-flex;
  flex-wrap: wrap;
`;

export const Autocomplete = styled(materialUI.Autocomplete)`
  overflow: hidden;
`;

export const FooterDialog = styled.div`
  margin-top: 26px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  gap: 8px;
  .disabled {
    opacity: 0.7;
  }
`;

export const Timeline = styled(materialUI.Timeline)``;
export const TimelineConnector = styled(materialUI.TimelineConnector)`
  background-color: ${colors.Primaryv5};
`;
export const TimelineItem = styled(materialUI.TimelineItem)``;
export const TimelineContent = styled(materialUI.TimelineContent)``;
export const TimelineSeparator = styled(materialUI.TimelineSeparator)`
  position: relative;
`;
export const Img = styled.img`
  position: absolute;
  top: 30px;
`;
export const CardTask = styled.div`
  border: 1px solid ${colors.Primaryv5};
  border-radius: 16px;
  margin: 10px 0px 10px 0px;
`;
export const Row = styled.div`
  display: flex;
  margin: 16px 16px 0px 16px;
  flex-direction: row;
`;

export const RowNoPd = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const RowGap = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;
export const LineRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;
export const Text = styled.div`
  font-family: Inter;
  font-size: 14px;
  color: ${colors.grey9};
  margin: 8px 0px -4px 8px;
`;

export const Subtitle = styled.p`
  width: 353px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  display: flex;
  align-items: center;
  letter-spacing: 0.15px;
  color: #000000;
`;

export const NotFoundText = styled.p`
  font-family: Inter;
  font-size: 14px;
  color: ${colors.grey9};
  margin: 8px 0px -4px 8px;
  text-align: center;
`;

export const BoxImg = styled.div`
  width: 25px;
  height: 25px;
  border-radius: 100%;
  background: ${colors.White};
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 30px;
  border: 2px solid #d2d8e8;

  img {
    width: 50%;
    position: relative;
    top: unset;
  }
`;
export const DesktopDatePicker = styled(materialUI.DesktopDatePicker)`
  width: 100%;
`;
export const TimePicker = styled(materialUI.TimePicker)`
  width: 100%;
`;
export const LocalizationProvider = styled(materialUI.LocalizationProvider)`
  display: flex;
  align-items: center;
`;
export const FormControlLabel = styled(materialUI.FormControlLabel)`
  .MuiFormControlLabel-label {
    font-size: 13.3291px;
    line-height: 10px;
    display: flex;
    align-items: center;
    color: ${colors.almostBlack};
  }
  &.switch-control {
    width: calc(100% - 32px);
    margin-top: 0;

    .MuiFormControlLabel-label {
      margin-top: 8px;
      font-size: 16px;
      line-height: 16px;
    }
  }
`;
export const Checkbox = styled(materialUI.Checkbox)``;

export const DividerNovaTarefa = styled.div`
  width: 90%;
  height: 20px;
  border-bottom: 1px solid #d2d8e8;
  text-align: center;
  margin: 36px auto;
  p {
    padding: 10px;
    background-color: #ffffff;
    width: 200px;
    margin: 0 auto;

    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    color: #424248;
    font-family: Inter-Medium;
  }
`;

export const ContainerConfirm = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
  width: 100%;
  height: 100%;
  border-radius: 4px;

  &.desqualify-confirm {
    top: -30%;
  }
  &.newTask-confirm {
    bottom: 30vh;
    top: unset;
  }
`;

export const HeaderContent = styled.div`
  border-radius: 4px 4px 0px 0px;
  background: ${colors.Success};
  padding: 30px;
  position: relative;

  .icon-close {
    position: absolute;
    top: 26px;
    right: 26px;
    cursor: pointer;
  }
`;

export const HeaderTitle = styled.h1`
  font-family: Inter-Medium;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: -0.01em;
  color: ${colors.White};
  width: 100%;
  text-align: center;
`;

export const BoxImgSuccess = styled.div`
  width: 33.94px;
  margin: 0 auto;
  margin-bottom: 10px;
  svg {
    width: 100%;
  }
`;

export const InfoContent = styled.div`
  background: #ffffff;
  border-radius: 0px 0px 4px 4px;
  padding: 17px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &.info-newTask {
    padding: 32px;
  }
`;

export const TitleInfo = styled.h2`
  font-family: Inter;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: -0.01em;
  color: #333333;
  width: 100%;
  text-align: center;
  margin-bottom: 40px;
  font-weight: 600;
`;

export const Title = styled.p`
  font-family: Inter;
  font-size: 22px;
  line-height: 24px;
  color: #000;
  width: 100%;
`;

export const SubTitleInfo = styled.h2`
  font-family: Inter;
  font-size: 0.875rem;
  line-height: 19px;
  text-align: left;
  letter-spacing: -0.01em;
  color: #a3a3a6;
  width: 100%;
  margin-bottom: 2rem;
  font-weight: 400;
`;

export const BoxImgArt = styled.div`
  width: 216.08px;
  margin-bottom: 40px;
  img {
    width: 100%;
  }
`;
export const BoxTaskInfo = styled.div`
  width: 100%;
  border: 1px solid ${colors.cardBorder};
  border-radius: 8px;
  padding: 29px 16px;
  margin-bottom: 32px;
`;

export const TaskConcludeText = styled.p`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: -0.01em;
  color: ${colors.grey1};
  margin-bottom: 8px;
  display: flex;
  align-items: center;

  svg {
    margin-right: 8px;
  }

  &.text-title {
    font-size: 16px;
    margin-bottom: 16px;
  }
  &.text-nameLead {
    margin-bottom: 29px;
  }
`;

export const LinkReturn = styled.span`
  width: 100%;
  background: ${colors.Primary50};
  border-radius: 4px;
  padding: 14px;
  text-align: center;
  text-decoration: none;
  font-family: Inter-Medium;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 120%;
  color: #2d5bff;
  transition: all 0.3s;
  cursor: pointer;

  &:hover {
    background: rgba(45, 91, 255, 0.2);
  }

  &.conclude-btn {
    background: linear-gradient(
        268.28deg,
        #06d986 0%,
        rgba(6, 217, 134, 0) 100%
      ),
      #4a76fb;
    color: ${colors.White};
    margin-top: 16px;
  }
`;

export const ButtonVoltar = styled.button`
  width: 100%;
  border: 1px solid #a3a3a6;
  border-radius: 0.5rem;
  padding: 8px;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 120%;
  background-color: #ffffff;
  margin-top: 50px;
  color: #424248;
  &:hover {
    background: rgba(45, 91, 255, 0.09);
  }
  transition: all 0.3s;
  cursor: pointer;
`;

export const TextDivider = styled.span`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 24px 0px 48px 0px;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  color: #424248;
  font-family: Inter-Medium;

  &:before,
  &:after {
    content: "";
    width: 100%;
    height: 1px;
    background: #d2d8e8;
    margin: 0px 24px;
  }
`;

export const FormControl = styled(materialUI.FormControl)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 24px 16px 0px 16px;
`;

export const Select = styled(materialUI.Select)`
  width: calc(100% - 48px);
  margin-right: 8px;

  &.select-historic {
    width: 100%;
  }

  .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${colors.gray300};
    border-radius: 8px;
    legend {
      span {
        display: none;
      }
    }
  }
`;

export const MenuItemSelect = styled(materialUI.MenuItem)``;
export const Menu = styled(materialUI.Menu)``;
export const MenuItem = styled.div`
  font-family: Inter;
  height: 40px;
  display: flex;
  align-items: center;
  font-size: 14px;
  margin: 2px 10px 0px 10px;
  width: 252px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;

  p {
    margin-left: 32px;
  }

  :hover {
    background-color: rgb(224 226 236);
  }
`;

export const Switch = styled(materialUI.Switch)`
  .MuiSwitch-switchBase {
    bottom: -1px;
    top: unset;
    left: 5px;
  }
  .MuiSwitch-switchBase.Mui-checked {
    transform: translateX(14px);
  }
  .MuiSwitch-thumb {
    width: 16px;
    height: 16px;
  }
  .MuiSwitch-track {
    width: 36px;
    height: 20px;
    border-radius: 12px;
    background-color: #a3a3a6;
  }
  .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track {
    opacity: 1;
  }
  .MuiSwitch-colorSecondary.Mui-checked {
    color: ${colors.White};
  }
`;
export const FormContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
`;
export const Form = styled.form`
  display: flex;
  padding-bottom: 200px;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space}px !important;
`;

export const LabelIcon = styled.span`
  margin-top: 2px;
  position: relative;
  margin-left: 8px;
  cursor: pointer;

  &:hover {
    .float-text {
      visibility: visible;
      opacity: 1;
    }
  }
`;
export const FloatText = styled.span`
  position: absolute;
  display: block;
  left: 120%;
  top: -10%;
  width: 232px;
  height: 32px;
  background: #323232;
  border-radius: 8px;
  letter-spacing: -0.01em;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 12px;
  line-height: 130%;
  transition: all 0.3s;
  visibility: hidden;
  opacity: 0;

  .check-icon {
    margin-right: 8px;
  }
`;

export const RowDadosComp = styled.div`
  display: flex;
  margin-bottom: 1.5rem;
  justify-content: space-between;
  width: 80%;
`;

export const SpaceRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ContainerDadosComp = styled.div`
  display: flex;
  flex-direction: column;
  width: 200px;
  justify-content: left;
  gap: 0.25rem;
  p {
    font-family: Inter;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: left;
  }
`;
export const ContentModal = styled.div`
  padding: 24px;
`;
export const InfoModal = styled.p`
  font-family: Inter;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.Mediumgrey};
  margin-bottom: 20px;
  margin-top: -24px;

  span {
    color: ${colors.Secondary};
  }
`;
export const ScrollContentV2: any = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  max-height: ${(props: any) => props?.maxHeight}px;
  /* overflow: auto; */
  gap: 8px;
  min-height: ${(props: any) =>
    props?.minHeight ? `${props.minHeight}px` : "auto"};
  /* &::-webkit-scrollbar {
    display: none;
  } */
  /* scrollbar-width: thin;
  scrollbar-color: transparent transparent; */
  -webkit-overflow-scrolling: touch;
`;

export const ScrollContent: any = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  max-height: ${(props: any) => props?.maxHeight}px;
  overflow: auto;
  gap: 8px;
  min-height: ${(props: any) =>
    props?.minHeight ? `${props.minHeight}px` : "auto"};
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
  -webkit-overflow-scrolling: touch;
`;

export const ContainerDelete = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 0.5rem;
  background-color: #fff;
  padding-bottom: 26px;
  width: 500px;
  overflow: hidden;
`;

export const InfoModalDelete = styled.p`
  font-family: Inter;
  font-size: 18px;
  line-height: 22px;
  color: #303030;
  margin-bottom: 42px;

  span {
    color: #ff3355;
  }
`;

export const DeleteButton = styled(materialUI.Button)`
  width: calc(50% - 8px);
  height: 43px;
  border-radius: 8px;
  background-color: #ff3355;
  span {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Inter-Medium;
    font-size: 16px;
    line-height: 24px;
    text-transform: capitalize;
    color: ${colors.white};
    transition: all 1s ease !important;
  }
  :hover {
    background-color: #f51137;
  }
`;
